import axios from "@axios";

export default {
  namespaced: true,

  actions: {
    async tokenRefresh() {
      const { data } = await axios.get("v1/token-refresh");

      if (!data) {
        return [];
      }
      return data;
    },

  },
};
